module.exports = __webpack_public_path__ + "media/images/countryrect/bm-2dfe731edee6ae05257ec8db9f915240.svg";